import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin } from '../../context/AdminContext';
import { useBlog } from '../../context/BlogContext';
import AdminBlogSidebar from '../../components/adminblog/AdminBlogSidebar';
import MediaUploader from '../../components/adminblog/MediaUploader';
import MediaGrid from '../../components/adminblog/MediaGrid';
import '../../styles/AdminBlog.css';

export default function AdminBlogMedia() {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAdmin();
  const { refreshMedia } = useBlog();

  useEffect(() => {
    if (!loading && !isAuthenticated) navigate('/adminblog');
  }, [isAuthenticated, loading, navigate]);

  // Recarga la biblioteca al entrar autenticado (por si se logueó en esta sesión).
  useEffect(() => {
    if (isAuthenticated) refreshMedia();
  }, [isAuthenticated, refreshMedia]);

  if (loading) return <div className="adminblog-loading">Loading...</div>;

  return (
    <div className="adminblog-page">
      <header className="adminblog-header">
        <div className="adminblog-header-left">
          <div className="adminblog-header-title">
            <h1>Blog Admin</h1>
          </div>
        </div>
      </header>

      <div className="adminblog-layout">
        <AdminBlogSidebar />
        <main className="adminblog-main">
          <div className="adminblog-content">
            <div className="adminblog-page-header">
              <h2>Media Library</h2>
            </div>
            <MediaUploader />
            <MediaGrid />
          </div>
        </main>
      </div>
    </div>
  );
}
